
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { privacyPolicyTopImage } from "@src/constants/images";
export const meta = {
  path: "/privacy_policy",
  title: "プライバシーポリシー",
  description: "レツミルのプライバシーポリシーです。",
  topImg: privacyPolicyTopImage
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`免責事項`}</h2>
    <p>{`レツミル(以下「当サイト」といいます。)に掲載している情報は、万全を期して調べたものではありますが、その内容の正確性や安全性を保障するものではありません。万が一、当サイトの情報のご利用等により、何らかの不都合や損失が発生したとしても、当サイトでは一切の責任は負いかねます。`}</p>
    <p>{`また、当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。`}</p>
    <p>{`あらかじめご了承ください。`}</p>
    <h2>{`アクセス解析ツールについて`}</h2>
    <p>{`当サイトではサイト利用者の利便性を向上する目的で Google アナリティクスというアクセス解析を利用しています。`}</p>
    <p>{`Google アナリティクスはトラフィック情報の収集のために Cookie を使用しています。このトラフィック情報は匿名で収集されており、個人を特定するものではありません。`}</p>
    <p>{`Cookie の無効化を希望される場合は、ウェブブラウザの設定を変更することにより Cookie を無効化することができます。`}</p>
    <h2>{`リンクについて`}</h2>
    <p>{`当サイトはリンクフリーです。ただし公序良俗に反したサイトからのリンクはお断りしています。`}</p>
    <p>{`また、当サイトの中には第三者のサイトへのリンクが含まれていますが、リンク先のサイトの真偽等については一切の責任を負いかねます。`}</p>
    <h2>{`プライバシーポリシーの変更について`}</h2>
    <p>{`当サイトは、個人情報に関して適用される日本の法令を遵守するとともに、本ポリシーの内容を適宜見直しその改善に努めます。`}</p>
    <p>{`修正された最新のプライバシーポリシーは常に本ページにて開示されます。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;